import { z } from 'zod';
// Dates cross every system boundary as ISO 8601 strings in UTC, e.g.
// "2026-06-11T09:00:00Z". Epoch milliseconds and locale-formatted strings
// ("11/06/2026 09:00") produce silent timezone drift across the widget, API,
// dashboard, and database boundaries. Conversion to a Date object happens at
// the point of use, never at the type boundary.
//
// Zod's `.datetime()` defaults to rejecting offsets — only the Z suffix is
// accepted. That is exactly what we want.
export const IsoDateTimeSchema = z.string().datetime();
//# sourceMappingURL=iso-date.js.map